import {h, Fragment} from "preact"
import { useEffect, useRef } from "preact/hooks"

export function SplideSlide({ ariaLabel, children }) {
    return (
        <li class="splide__slide">
            {children}
        </li>
    )
}

export function SplideCarousel({ className, ariaLabel, options = {}, watchChildren, mount, children }) {
    const splideElRef = useRef(null);
    const instanceRef = useRef(null);

    useEffect(() => {
        if(!instanceRef?.current && splideElRef?.current && window.Splide) {
            instanceRef.current = new window.Splide(splideElRef.current, options)
            splideElRef.current._splide = instanceRef.current;
            if(mount) {
                instanceRef.current.mount();
            }
        }
        return () => {
            if(instanceRef.current){
                instanceRef.current.destroy(true);
                splideElRef.current._splide = null;
                instanceRef.current = null;
            }
        }
    }, [])

    useEffect(() => {
        if(watchChildren && instanceRef.current) {
            instanceRef.current.refresh();
        }
    }, [ watchChildren, children ])

    return (
        <div 
            class={`splide ${className}`} 
            aria-label={ariaLabel}
            ref={splideElRef} 
        >
            <div class="splide__track">
                <ul class="splide__list">
                    {children}
                </ul>
            </div>
        </div>
    )
}
